import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef} from '@angular/material/dialog';
import { AuthenticationService } from '../service/authentication.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { first } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SeoService } from '../service/seo.service';
import { GlobalComponent } from '../global/global.component';

@Component({
  selector: 'app-webinarlive',
  templateUrl: './webinarlive.component.html',
  styleUrls: ['./webinarlive.component.scss']
})
export class WebinarliveComponent implements OnInit {

  constructor(private SEOService:SeoService, private authenticationService: AuthenticationService,
    public dialog: MatDialog,
    public toastr: ToastrManager,private router: Router) { }
hostName = GlobalComponent.hostName;
  ngOnInit(): void {
    window.scroll(0,0);   
    this.SEOService.updateCanonicalUrl(this.hostName + '/webinars');
  }
  signup()
    {
      this.router.navigate(['/login/signup']);

    }
 openDialog(): void {
    this.dialog.open(webinarComponent, {
      width: '500px',
      
    }  
    
    );
}}

@Component({
  selector: 'app-demo',
  templateUrl: './webinar.component.html',
  styleUrls: ['./webinarlive.component.scss']
  
})
export class webinarComponent implements OnInit {
  leadForm: UntypedFormGroup;
  submitted = false;

  constructor(public dialogRef: MatDialogRef<webinarComponent>,
    private formBuilder: UntypedFormBuilder,
    private authenticationService: AuthenticationService,
    public toastr: ToastrManager) {}

    ngOnInit() {
        this.leadForm = this.formBuilder.group({
            company_name: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            phone: ['', [Validators.required, Validators.minLength(10), Validators.pattern("^[0-9]*$")]],
        });
    }
  
    // convenience getter for easy access to form fields
    get f() { return this.leadForm.controls; }
  
    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.leadForm.invalid) {
            return;
        }
  
        //console.log(this.f.email.value);
          this.authenticationService.create_lead(this.f.company_name.value, this.f.email.value, this.f.phone.value, 0)
              .pipe(first())
              .subscribe(
                  data => {
                    //console.log(data);
                    this.toastr.successToastr("Thank You!", 'Our Team will call you within 24 hours!');
                  },
                  error => {
                  });
    
        this.dialogRef.close();
         
    }
    
}



